import Stage1Player5Room from "../shared/Stage1Player5Room";

export default function Six_Players_Stage1_Player5(props) {
  return <Stage1Player5Room {...props} playerCount={6} />;
}